export default __webpack_public_path__ + "static/media/bus.208ac4bc.png";